"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Container = _interopRequireDefault(require("../../foundational/Layout/Container"));
var _Breadcrumb = _interopRequireDefault(require("../../atoms/Breadcrumb"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["links", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".Breadcrumbs {\n  background: #f7f7f7;\n  margin: 0;\n  padding: 1rem 0;\n}\n.Breadcrumbs nav {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}";
  var fileName = "Breadcrumbs_Breadcrumbs";
  var element = document.querySelector("style[data-sass-component='Breadcrumbs_Breadcrumbs']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Breadcrumbs = function Breadcrumbs(_ref) {
  var _ref$links = _ref.links,
    links = _ref$links === void 0 ? [] : _ref$links,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var match = window.location.pathname.split('/');
  var clean = match.filter(function (el) {
    return el !== '';
  });
  var createPath = function createPath(i) {
    var path;
    for (var index = 0; index <= i; index += 1) {
      if (index === 0) {
        path = "/".concat(clean[index]);
      } else {
        path += "/".concat(clean[index]);
      }
    }
    return path;
  };
  var builtObject = clean.reduce(function (urls, url, i) {
    return _objectSpread(_objectSpread({}, urls), {}, (0, _defineProperty2["default"])({}, url, {
      name: url,
      path: createPath(i)
    }));
  }, {});
  var trueLinks = links.length > 0 ? links : Object.values(builtObject);
  var unSlug = function unSlug(slug) {
    return slug.replace(/[^a-zA-Z0-9 ]/g, ' ');
  };
  var breadCrumbLinks = trueLinks.map(function (link, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Breadcrumb["default"], {
      href: "".concat(link.path),
      arrow: index !== trueLinks.length - 1,
      "aria-current": index === trueLinks.length - 1 && 'page',
      children: link.name && unSlug(link.name)
    }, index);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", _objectSpread(_objectSpread({
    className: "Breadcrumbs ".concat(className)
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container["default"], {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", {
        "aria-label": "Breadcrumb",
        children: [links.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Breadcrumb["default"], {
          href: "/",
          arrow: breadCrumbLinks.length >= 1,
          children: "Home"
        }), breadCrumbLinks]
      })
    })
  }));
};
var _default = Breadcrumbs;
exports["default"] = _default;